import React from 'react'
import useIpfs from 'src/common/queries/useIpfs'
import { usePriceFeed } from 'src/common/queries/usePriceFeeds/usePriceFeed'
import { AnyToken } from 'src/common/types/models/Tokens'
import Drawer from 'src/common/ui-kit/Drawer'
import TokenInfoBody from './TokenInfoBody'
import TokenInfoHeader from './TokenInfoHeader'
import { TokenKya } from './types'
import { formatToIpfsUrl } from 'src/common/utils/formatters/string'
import TokenInfoNoKya from './TokenInfoNoKya'

interface TokenInfoProps {
  token: AnyToken | null
  isOpen: boolean
  onClose: () => void
}

const TokenInfo: React.FC<TokenInfoProps> = ({ token, isOpen, onClose }) => {
  const isCarbon =
    token?.contractAddress.toLocaleLowerCase() ===
    '0x0AAA36AD5DB4f4ea173B40A9428529ebAD73Fc89'.toLowerCase()
  if (isCarbon && !token.kya) {
    token.kya = 'ipfs://QmTKTr3hC7uJ899LCBFmVQqEbxAD1vSoHLUM1rwc6S3zy3/0'
  }
  const {
    data: tokenKya,
    isLoading,
    isError,
  } = useIpfs<TokenKya>(token?.kya && formatToIpfsUrl(token?.kya || ''), {
    enabled: Boolean(isOpen && token),
  })

  const { priceFeed } = usePriceFeed(token?.contractAddress)

  if (!token) return null

  return (
    <Drawer
      open={isOpen}
      onClose={onClose}
      className='max-w-md'
      position='right'
    >
      <TokenInfoHeader token={token} priceFeed={priceFeed} />
      <div className='divider' />
      {isLoading ? (
        <div className='loader size-10 mx-auto my-10' />
      ) : isError || !tokenKya ? (
        <TokenInfoNoKya />
      ) : (
        <TokenInfoBody tokenKya={tokenKya} />
      )}
    </Drawer>
  )
}

export default TokenInfo
